import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { SentEmailLogGetQueryParamsInterface } from '../../tasks/definitions/sent-email-log-get-query-params.interface';
import { PagedResponseInterface } from 'src/app/shared/classes/paged-response.interface';
import { createQueryParams } from '../../tasks/sent-email-logs-get-query-params-factory';
import { SentEmailLogListItemResponse } from '../../tasks/definitions/sent-email-log-response.interface';

@Injectable()
export class GetSentEmailLogsService {
    constructor(private client: HttpClient, private configService: ConfigService) {}
  
    public getSentEmailLogs(paramsObj: SentEmailLogGetQueryParamsInterface): Observable<PagedResponseInterface<SentEmailLogListItemResponse>> {
      const url = `${this.configService.config.rest.apiV2Url}/sent-email-logs`;
  
      const params: HttpParams = createQueryParams(paramsObj);
  
      return this.client.get<PagedResponseInterface<SentEmailLogListItemResponse>>(url, { params }).pipe(
        catchError(error => throwError(handleProblem(error)))
      );
    }
}